import { AuthService } from '../services/AuthService';

export const isExtension = process.env.IS_BROWSER_EXTENSION === 'true';
const authService = isExtension ? AuthService.getInstance() : null;

/**
 * Gets the authentication token based on the environment (extension or standalone)
 * @returns Promise<string | null> The authentication token
 */
export async function getAuthToken(): Promise<string | null | undefined> {
  let token = null;

  if (isExtension) {
    token = await authService?.getAuthToken();
  }

  return token;
}

export function getTenantIdFromLocalStorage(): string {
  return localStorage.getItem('defaultTenant') || '';
}
